var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"v2_page_loader",attrs:{"src":_vm.iframeSrc,"allow":"clipboard-write; fullscreen","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }